import { useState, useEffect, useContext, useRef } from 'react';
import { Modal } from 'bootstrap';
import { CatalogDispatchContext, UxContext } from '../store/CatalogContext';
import parse from 'html-react-parser';

export default function UpsellDescriptionModal() {
  const catalogDispatch = useContext(CatalogDispatchContext);
  const ux = useContext(UxContext);

  const upsellDescriptionModalEl = useRef<HTMLDivElement>(null);

  const [upsellDescriptionModal, setUpsellDescriptionModal] = useState<Modal | null>(null);
  const [upsellItem, setUpsellItem] = useState({
    name: '',
    description: '',
  });

  useEffect(() => {
    if (upsellDescriptionModalEl.current) {
      setUpsellDescriptionModal(new Modal(upsellDescriptionModalEl.current));

      upsellDescriptionModalEl.current.addEventListener('hide.bs.modal', () => {
        // trigger to hide the toast notification
        catalogDispatch({
          type: 'UX',
          payload: {
            showUpsellDescription: null,
          },
        });
      });
    }
  }, [catalogDispatch]);

  useEffect(() => {
    if (!ux.showUpsellDescription && upsellDescriptionModal) {
      upsellDescriptionModal.hide();
    }
    if (ux.showUpsellDescription && upsellDescriptionModal) {
      upsellDescriptionModal.show();
    }
  }, [ux.showUpsellDescription, upsellDescriptionModal]);

  useEffect(() => {
    if (ux.showUpsellDescription) {
      setUpsellItem({
        name: ux.showUpsellDescription.name,
        description: ux.showUpsellDescription.description,
      });
    }
  }, [ux.showUpsellDescription]);

  return (
    <div
      className="modal fade text-start lh-16"
      ref={upsellDescriptionModalEl}
      id="upsell-description-modal"
      tabIndex={-1}
      aria-hidden="true"
    >
      <div className="upsell-description-modal modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-body p-3 p-md-4">
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            <h3 className="modal-title fw-600 h5 mb-2">{upsellItem.name}</h3>
            <div className="line-break description-wrap fw-400 mb-0">{parse(upsellItem.description)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
